import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import Modal from "@/components/Modal";
import { toast } from "sonner";

export default function Tenants() {
  const [tenants, setTenants] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({ tenant_name: "", admin_name: "", admin_email: "", admin_password: "" });

  const load = useCallback(async () => {
    const { data } = await api.get("/tenants");
    setTenants(data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const create = async () => {
    if (!form.tenant_name.trim() || !form.admin_email.trim() || !form.admin_password) {
      toast.error("All fields are required"); return;
    }
    try {
      await api.post("/tenants", form);
      toast.success("Tenant created");
      setModalOpen(false);
      setForm({ tenant_name: "", admin_name: "", admin_email: "", admin_password: "" });
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not create tenant");
    }
  };

  const toggleActive = async (t) => {
    await api.patch(`/tenants/${t.id}`, { is_active: !t.is_active });
    load();
  };

  return (
    <section className="view" data-testid="tenants-page">
      <div className="page-head">
        <div>
          <div className="eyebrow">Platform · super admin</div>
          <h1>Tenants</h1>
          <p>Create a business account and its first Admin.</p>
        </div>
        <button className="btn btn-primary" onClick={() => setModalOpen(true)} data-testid="add-tenant-btn">＋ New tenant</button>
      </div>
      <div className="card">
        <div className="table-wrap">
          <table data-testid="tenants-table">
            <tbody>
              <tr><th>Tenant</th><th>Admin</th><th>Shops</th><th>Status</th><th></th></tr>
              {tenants.map((t) => (
                <tr key={t.id} data-testid={`tenant-row-${t.id}`}>
                  <td>{t.name}</td>
                  <td>{t.admin_name} <span className="mono" style={{ color: "var(--fg-faint)" }}>({t.admin_email})</span></td>
                  <td className="mono">{t.shop_count}</td>
                  <td><span className={`status ${t.is_active ? "active" : "inactive"}`}>{t.is_active ? "Active" : "Inactive"}</span></td>
                  <td><button className={`btn ${t.is_active ? "btn-danger" : "btn-primary"} btn-sm`} onClick={() => toggleActive(t)} data-testid={`toggle-tenant-${t.id}`}>{t.is_active ? "Deactivate" : "Activate"}</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {tenants.length === 0 && <div className="empty" style={{ margin: 20 }}>No tenants yet — create the first one</div>}
      </div>

      <Modal open={modalOpen} onClose={() => setModalOpen(false)} title="New tenant"
        footer={<button className="btn btn-primary" onClick={create} data-testid="create-tenant-submit-btn">Create tenant</button>}>
        <div><label className="field-label">Business name</label><input className="input" style={{ width: "100%" }} value={form.tenant_name} onChange={(e) => setForm({ ...form, tenant_name: e.target.value })} data-testid="tenant-name-input" /></div>
        <div><label className="field-label">Admin name</label><input className="input" style={{ width: "100%" }} value={form.admin_name} onChange={(e) => setForm({ ...form, admin_name: e.target.value })} data-testid="tenant-admin-name-input" /></div>
        <div><label className="field-label">Admin email</label><input type="email" className="input" style={{ width: "100%" }} value={form.admin_email} onChange={(e) => setForm({ ...form, admin_email: e.target.value })} data-testid="tenant-admin-email-input" /></div>
        <div><label className="field-label">Admin password</label><input type="password" className="input" style={{ width: "100%" }} value={form.admin_password} onChange={(e) => setForm({ ...form, admin_password: e.target.value })} data-testid="tenant-admin-password-input" /></div>
      </Modal>
    </section>
  );
}
